import ObjectCopyService from "external-services/object-copy-service/index";
import AdminService from "external-services/diary-admin-service/admin.service";
import StatusConfigService from "external-services/status-config-service/index";
import DateUtilsService from "external-services/date-utils-service";
import PouchLoadService from "external-services/pouch-load-service/index";
import TrackingService from "app/services/tracking/tracking.service";
import LoginActions from "app/actions/login.actions";
import VenueActions from "app/actions/venue.actions";
import PouchActions from "app/actions/pouch.actions";
import store from 'appRoot/Store';
import {loadStatuses} from 'app/reducers/status/slice';
import {loadLayout} from 'app/reducers/layout/slice';
import {loadSchedules} from "app/reducers/schedule/slice";

const NS = 'WizardCtrl'; // jshint ignore:line

/**
 * used 'templateUrl' so that the `node-scripts/gather-angularjs-template-urls.js` script can detect dynamically loaded html
 */

export default function WizardCtrl(
  $log, $scope, $state, $filter, pouchService, setupService,
    tablesService, scheduleService
) {
  "ngInject";

  const vm = this;

  var hasSectionsChanged = true;
  var welcomeTab = {
    name: 'Welcome',
    id: 'welcome',
    disabled: false,
    templateUrl: 'app/wizard/welcome.html'
  };

  vm.SAVING = 1;
  vm.ENTER = 0;
  vm.SUCCESS = 2;
  vm.ERROR = 3;

  vm.state = vm.ENTER;
  vm.step = 0;
  vm.canSave = false;
  vm.isDisabled = false;

  vm.sectionsTab = {
    name: 'Sections',
    id: 'sections',
    disabled: true,
    templateUrl: 'app/wizard/sections.html',
    displayErrors: false,
    checkCount: 0
  };
  vm.layoutTab = {
    name: 'Layouts',
    id: 'layout',
    disabled: true,
    templateUrl: 'app/wizard/layouts.html',
    displayErrors: false,
    checkCount: 0
  };
  vm.servicesTab = {
    name: 'Services',
    id: 'services',
    disabled: true,
    templateUrl: 'app/wizard/services.html',
    displayErrors: false,
    checkCount: 0
  };
  vm.scheduleTab = {
    name: 'Schedule',
    id: 'schedule',
    disabled: true,
    templateUrl: 'app/wizard/schedule.html',
    displayErrors: false,
    checkCount: 0
  };
  vm.completeTab = {
    name: 'Confirm settings',
    id: 'confirm',
    disabled: true,
    templateUrl: 'app/wizard/confirm.html'
  };

  var steps = [welcomeTab, vm.sectionsTab, vm.layoutTab, vm.servicesTab, vm.scheduleTab, vm.completeTab];
  for (var i = steps.length - 1; i >= 0; i--) {
    steps[i].order = i;
  }
  vm.steps = steps;

  // data
  vm.sections = [];
  vm.layouts = [];
  vm.venue = AdminService.getVenue();
  vm.schedule = {
    boookingInterval: 15,
    days: []
  };
  vm.services = [];

  //-- define public methods
  vm.goBackAStep = goBackAStep;
  vm.goToNextStep = goToNextStep;
  vm.checkDisbaled = checkDisbaled;
  vm.createVenue = createVenue;
  vm.retry = retry;

  checkAllowed();

  function checkAllowed() {
    scheduleService.getAllDaySchedules().then(function (schedules) {
      if (schedules && schedules.rows.length) {
        $state.transitionTo('bookings');
        return;
      }
      init();
    }).catch(function () {
      init();
    });
  }

  function init() {
    $scope.$watch('wizardCtrl.step', updateSteps);
    $scope.$watch('wizardCtrl.sections', sectionsChanged, true);
    updateSteps();
  }

  function goBackAStep() {
    vm.step--;
  }

  function goToNextStep() {
    if (!this.steps[this.step].disabled) {
      vm.step++;
    } else {
      this.steps[this.step].displayErrors = true;
      this.steps[this.step].checkCount++;
    }
  }

  function retry() {
    vm.state = vm.ERROR;
  }

  function checkDisbaled(index) {
    var disabled = false;
    for (var i = 0; i < index; i++) {
      var step = vm.steps[i];
      if (step.disabled) {
        disabled = true;
        break;
      }
    }
    return disabled;
  }

  function sectionsChanged() {
    hasSectionsChanged = true;
  }

  function updateSteps() {
    vm.nextStep = (vm.step === vm.steps.length - 1) ? false : vm.steps[vm.step + 1];
    vm.previousStep = (vm.step === 0) ? false : vm.steps[vm.step - 1];
    var currentStep = vm.steps[vm.step];
    if (hasSectionsChanged) {
      checkLayouts();
    }

    if (currentStep.id === 'schedule') {
      if (vm.schedule.days.length === 0) {
        createScheduleDays();
      }
    }

    vm.canSave = (vm.step === (vm.steps.length - 1));
  }

  function checkLayouts() {
    // check the layout data before we create them
    // make sure their is a layout for every section
    var validFromDate = DateUtilsService.dateToIdStr(new Date(2014, 0, 1));
    var layoutLookup = {};
    var layout;

    if (!vm.layouts) {
      vm.layouts = [];

    } else {
      for (var i = vm.layouts.length - 1; i >= 0; i--) {
        layout = vm.layouts[i];
        layoutLookup[layout.sectionId] = layout;
      }
    }

    for (var j = 0; j < vm.sections.length; j++) {
      var section = vm.sections[j];
      var addTables = true;
      layout = layoutLookup[section._id];
      if (layout) {
        if (layout.tables.length === section.tableNumber) {
          addTables = false;
        }
      }

      if (addTables) {
        // create the tables
        var tables = [];
        var tableNum = section.tablesStartAt;
        for (var t = 0; t < section.tableNumber; t++) {
          tables.push({
            name: tableNum,
            order: t,
            shared: false,
            priority: null,
            capacity: 2,
            minCapacity: 1,
            online: true,
            walkinOnly: false,
            availableOption: 'all',
            shape: 'square',
            shapeUpdated: false,
            _id: PouchLoadService.getNewId(['table'])
          });
          tableNum++;
        }
        if (layout) {
          layout.name = section.name;
          layout.tables = tables;
          layout.order = section.order;
        } else {
          vm.layouts.push({
            _id: PouchLoadService.getNewId(['layout'], true, [validFromDate]),
            name: section.name,
            sectionId: section._id,
            tables: tables,
            order: section.order
          });
        }
      } else {
        layout.name = section.name;
        layout.order = section.order;
      }
    }

    // remove deleted sections
    if (vm.sections.length !== vm.layouts.length) {
      var sectionIds = vm.sections.map(function (s) {
        return s._id;
      });
      // a section has been deleted;
      for (var n = vm.layouts.length - 1; n >= 0; n--) {
        layout = vm.layouts[n];
        if (sectionIds.indexOf(layout.sectionId) === -1) {
          // section not found
          vm.layouts.splice(n, 1);
        }
      }
    }

    hasSectionsChanged = false;
  }

  function createVenue() {
    vm.state = vm.SAVING;
    var sections = createSections();
    var layouts = createLayouts();
    var tables = createTables();

    var schedule = createSchedule(layouts);
    setupService.deleteAll()
      .then(function () {
        // add all the wizard doc
        var allDocs = [];
        allDocs = allDocs.concat(sections);
        allDocs = allDocs.concat(layouts);
        allDocs = allDocs.concat(tables);
        allDocs = allDocs.concat(schedule);
        return PouchLoadService.getDbLocal().bulkDocs(allDocs);
      })
      .then(function () {
        return setupService.addBookingStatus();
      }).then(function () {
        return setupService.addTagTypes();
      }).then(async function () {
        pouchService.created = true;
        // load redux
        await store.dispatch(loadStatuses());
        await store.dispatch(loadSchedules());
        await store.dispatch(loadLayout());

        // StatusConfigService.init({
        //   standByList: AdminService.getVenue().standByList,
        //   trackEvent: (...args) => TrackingService.trackEvent(...args),
        //   LoginActions, VenueActions, PouchActions
        // }).then(() => {
        //   store.dispatch(loadStatuses());
        // });
        vm.state = vm.SUCCESS;
      }).catch(function (err) {
        vm.state = vm.ERROR;
        $log.error('fiald to create resturant', err);
      });
  }

  function createSections() {
    var sections = ObjectCopyService.angularSafeCopy(vm.sections);
    for (var i = sections - 1; i >= 0; i--) {
      var section = sections[i];
      delete section.tablesStartAt;
      delete section.tableNumber;
      delete section.$$hashKey;
    }
    return sections;
  }

  function createLayouts() {
    var layouts = ObjectCopyService.angularSafeCopy(vm.layouts);
    for (var i = layouts.length - 1; i >= 0; i--) {
      var layout = layouts[i];
      delete layout.$$hashKey;
      // convert the tables array to a list of table ids
      var tableIds = [];
      for (var t = 0; t < layout.tables.length; t++) {
        tableIds.push(layout.tables[t]._id);
      }
      layout.tables = tableIds;
    }
    return layouts;
  }

  function createTables() {
    var layouts = ObjectCopyService.angularSafeCopy(vm.layouts);
    var tables = [];
    for (var i = layouts.length - 1; i >= 0; i--) {
      var layout = layouts[i];
      var sectionId = layout.sectionId;
      delete layout.$$hashKey;

      for (var t = 0; t < layout.tables.length; t++) {
        var table = layout.tables[t];
        tablesService.setBookingOptions(table);
        if (!table.shape) {
          if (table.capacity <= 4) {
            table.shape = 'square';
          } else {
            table.shape = 'rect';
          }
        }
        delete table.$$hashKey;
        delete table.shapeUpdated;
        // add the section object to the tables
        table.sectionId = sectionId;
        tables.push(table);
      }
    }
    return tables;
  }

  function createScheduleDays() {
    vm.schedule.days = [];
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var date = new Date(2014, 0, 1);
    var validFromDate = DateUtilsService.dateToIdStr(date);
    vm.services = $filter('orderBy')(vm.services, 'startTime');
    for (var i = 0; i < days.length; i++) {
      var day = days[i];
      // add the services
      var serviceList = [];
      for (var s = 0; s < vm.services.length; s++) {
        var service = ObjectCopyService.angularSafeCopy(vm.services[s]);
        service._id = PouchLoadService.getNewId(['service']);
        serviceList.push(service);
      }
      var schedule = {
        _id: PouchLoadService.getNewId(['schedule', 'day', i], true, [validFromDate]),
        dayNum: i,
        isOpen: true,
        dayName: day,
        boookingInterval: vm.schedule.boookingInterval,
        services: serviceList
      };

      vm.schedule.days.push(schedule);
    }
  }

  function createSchedule(layouts) {
    var schedules = [];
    for (var i = 0; i < vm.schedule.days.length; i++) {
      var schedule = ObjectCopyService.angularSafeCopy(vm.schedule.days[i]);
      delete schedule.edit;
      var sectionLayouts = [];
      // create layouts for each section
      for (var l = 0; l < layouts.length; l++) {
        var layout = layouts[l];
        // remove the vaild date from the joined layout
        var layoutParts = layout._id.split('_');
        layoutParts.pop();
        var layoutId = layoutParts.join('_');
        sectionLayouts.push({
          sectionId: layout.sectionId,
          layoutId: layoutId
        });
      }
      // add the services
      for (var s = 0; s < schedule.services.length; s++) {
        var service = schedule.services[s];
        service.startTime = $filter('date')(service.startTime, 'HH:mm');
        service.lastBookingTime = $filter('date')(service.lastBookingTime, 'HH:mm');
        service.endTime = $filter('date')(service.endTime, 'HH:mm');
        service.sectionLayouts = sectionLayouts;
        delete service.$$hashKey;
      }
      schedule.services = $filter('orderBy')(schedule.services, 'startTime');
      schedules.push(schedule);

    }
    return schedules;
  }
}
